import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "header-wrapper" }
const _hoisted_2 = { class: "logo-wrapper" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "duration-badge" }
const _hoisted_5 = { class: "track-number" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "track-info" }
const _hoisted_8 = { class: "track-name" }
const _hoisted_9 = { class: "track-duration" }
const _hoisted_10 = { class: "track-actions" }
const _hoisted_11 = { class: "play-button-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, {
        class: "main-background-dark",
        fullscreen: true,
        slot: "fixed",
        "scroll-y": false
      }, {
        default: _withCtx(() => [
          _cache[0] || (_cache[0] = _createElementVNode("div", { class: "release-safe-area" }, null, -1)),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("img", {
                src: _ctx.programLogo || _ctx.getProgramImage(_ctx.releaseEntity.programShortName),
                alt: "program logo"
              }, null, 8, _hoisted_3)
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_ion_icon, { icon: _ctx.timeOutline }, null, 8, ["icon"]),
              _createElementVNode("span", null, _toDisplayString(_ctx.mediaUtils.formatTime(_ctx.mediaUtils.getTotalPlaylistDuration(_ctx.musicList))), 1)
            ])
          ]),
          _createVNode(_component_ion_content, { class: "bg-transparent music-list" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_list, {
                class: "bg-transparent",
                lines: "none"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.musicList, (audioTrack, idx) => {
                    return (_openBlock(), _createBlock(_component_ion_item, {
                      key: idx,
                      onClick: ($event: any) => (_ctx.selectTrack(idx)),
                      class: _normalizeClass(["music-item", { 'playing': !_ctx.isFirstSelect && _ctx.playerBar.currentTrackIdx === idx }])
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_5, [
                          (!(_ctx.playerBar.currentTrackIdx === idx && !_ctx.isFirstSelect))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(idx + 1), 1))
                            : (_openBlock(), _createBlock(_component_ion_icon, {
                                key: 1,
                                icon: _ctx.play,
                                class: "playing-icon"
                              }, null, 8, ["icon"]))
                        ]),
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.mediaUtils.getTrackName(audioTrack)), 1),
                          _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.getTrackDuration(audioTrack)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_10, [
                          (audioTrack.isOffline)
                            ? (_openBlock(), _createBlock(_component_ion_icon, {
                                key: 0,
                                icon: _ctx.cloudDone,
                                class: "offline-icon"
                              }, null, 8, ["icon"]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_11, [
                            _createVNode(_component_ion_icon, {
                              icon: !_ctx.isFirstSelect && _ctx.playerBar.currentTrackIdx === idx ? _ctx.pause : _ctx.play,
                              class: "play-icon"
                            }, null, 8, ["icon"])
                          ])
                        ])
                      ]),
                      _: 2
                    }, 1032, ["onClick", "class"]))
                  }), 128))
                ]),
                _: 1
              }),
              _createVNode(_component_ion_item, {
                class: "fake-footer bg-transparent",
                lines: "none"
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}